export default {"src":"/_next/static/media/CC.f0f10ba8.svg","height":18,"width":18};